// App.js
import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import SidebarWithHeader from './SidebarWithHeader'; // Adjust the import path as necessary
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import Home from './Screens/Home';
import Statistics from './Screens/Statistics';
import Content from './Screens/Content';
import Upload from './Screens/Upload';
import Settings from './Screens/Settings';
import Login from './Screens/Login';
import Success from "./Screens/Success";
import { AuthProvider, useAuth } from './AuthContext';

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <SidebarWithHeader>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/content" element={<Content />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/success" element={<Success />} />
        <Route path="/settings" element={<Settings />} />
       
        <Route path="*" element={<Navigate to="/" />} />{' '}
        {/* Redirect unknown routes to Home */}
      </Routes>
    </SidebarWithHeader>

  ) : (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" />} />{' '}
      {/* Redirect unknown routes to Login */}
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ChakraProvider>
          <AppRoutes />
        </ChakraProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
